import { createSignal, Show } from "solid-js";
import { View, Text, hexColor } from "@lightningtv/solid";
import { fontFamily } from "../../translations/configuration";

const InputField = (props: {
  ref?: (el: any) => void;
  y?: number;
  placeholder: string;
  value?: string;
  onEnter?: () => void;
  onUp?: () => void;
  onDown?: () => void;
  onLeft?: () => void;
  autofocus?: boolean;
}) => {
  const [focused, setFocused] = createSignal(false);
  const w = 900;
  return (
    <View
      ref={props.ref}
      x={0} y={props.y ?? 0}
      width={w} height={68}
      borderRadius={12}
      autofocus={props.autofocus}
      onFocus={() => setFocused(true)}
      onBlur={() => setFocused(false)}
      onEnter={props.onEnter}
      onUp={props.onUp}
      onDown={props.onDown}
      onLeft={props.onLeft}
    >
      <Show when={focused()}>
        <View x={-2} y={-2} width={w + 4} height={72} borderRadius={14} color={hexColor("#2563eb")} zIndex={-1} />
      </Show>
      <View x={0} y={0} width={w} height={68} borderRadius={12} color={hexColor("#0d1117")}>
        <Text x={22} y={20} style={{ fontSize: 24, color: hexColor(props.value ? "#f0f6fc" : "#4b5563"), fontFamily: fontFamily() }}>
          {props.value || props.placeholder}
        </Text>
      </View>
    </View>
  );
};

export default InputField;
